/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';
import { ClientRoleAssignment, ClientRoleInformation } from '@DigitaleDoerfer/digitale-doerfer-api';
import { Grid, Theme, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import RoleAssignmentListView from './RoleAssignmentList.view';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const useStyles = makeStyles((theme: Theme) => ({
	gridTitle: {
		paddingTop: '0 !important',
		paddingBottom: '0 !important',
		marginBottom: '0 !important'
	},
	gridTable: {
		paddingTop: '0 !important'
	}
}));

interface Props {
	allAvailableRoles: ClientRoleInformation[];
	userRoles: ClientRoleAssignment[];
	roleActionProvider?: (role: ClientRoleAssignment) => JSX.Element;
}

function RoleAssignmentListFormView(props: Props): JSX.Element | null {
	const { allAvailableRoles, userRoles, roleActionProvider } = props;
	const classes = useStyles();

	return (
		<Grid container>
			<Grid item xs={12} className={classes.gridTitle}>
				<Typography variant="h2" gutterBottom>
					Rollen
				</Typography>
			</Grid>
			<Grid item xs={12} className={classes.gridTable}>
				<RoleAssignmentListView
					allAvailableRoles={allAvailableRoles}
					userRoles={userRoles}
					roleActionProvider={roleActionProvider}
				/>
			</Grid>
		</Grid>
	);
}

export default RoleAssignmentListFormView;
